"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GROUP_UPDATE = exports.GROUP_SEARCH = exports.GROUP_REGISTER_CSV = exports.GROUP_REGISTER = exports.GROUP_LIST_SEARCH = exports.GROUP_DOWNLOAD = exports.GROUP_DETAILS_SEARCH = exports.GROUP_DELETE = exports.GROUPHISAI_UPDATE_INFO = exports.GROUPHISAI_UPDATE = exports.GROUPHISAI_SORT = exports.GROUPHISAI_SEARCH = exports.GROUPHISAI_KBN = exports.GROUPHISAI_HOMELIST = exports.GROUPHISAI_HISTORY = exports.GROUPHISAI_DOWNLOAD = exports.GROUPHISAI_DETAIL = exports.GROUPHISAI_DELETE = exports.FRONT_LOG = exports.FAQ_UPDATE = exports.FAQ_SEARCH = exports.FAQ_PERIOD = exports.FAQ_IMAGE = exports.FAQ_CATEGORY = exports.DOCUMENTMNG_UPLOAD = exports.DOCUMENTMNG_SEARCH = exports.DOCUMENTMNG_DOWNLOAD = exports.DOCUMENTMNG_DELETE = exports.DISASTER_UPDATE = exports.DISASTER_SELECT_SEARCH = exports.DISASTER_SEARCH = exports.DISASTER_REGIST = exports.DISASTER_REFER = exports.DISASTER_DELETE = exports.CHECK_MAIL_ADDRESS = exports.BUILDING_UPDATE = exports.BUILDING_SELECT_SEARCH = exports.BUILDING_SEARCH = exports.BUILDING_REGISTER = exports.BUILDING_REFER = exports.BUILDING_LIST_SEARCH = exports.BUILDING_DELETE = exports.BIZ_USER_UPDATE = exports.BIZ_USER_SEARCH = exports.BIZ_USER_REGISTER = exports.BIZ_USER_REFER = exports.BIZ_USER_KAISHA_SOSHIKI_SEARCH = exports.BIZ_USER_DOMAINS_GET = exports.BIZ_USER_DELETE = exports.BIZ_USER_CSV_UPLOAD_REGISTERUPDATE = exports.BIZ_USER_CSV_UPLOAD_DELETE = exports.BIZ_USER_COMMON_DOWNLOAD = exports.BIZ_USER_COMMON_BIZ_USER_INFO = exports.BIZ_EXCLUSION_SEARCH = exports.BIZ_EXCLUSION_REGISTER = exports.BIZ_EXCLUSION_EXISTS = exports.BCPTGTJIGYO_SEARCH = exports.BCM_TARGET_SEARCH_UPDATE = exports.BCM_TARGET_SEARCH_DELETE = exports.BCM_TARGET_SEARCH = exports.BCM_TARGET_REGISTER_KAISHA_SOSHIKI = exports.BCM_TARGET_REGISTER = exports.BCM_SITE_KIND_INFO = exports.BCM_REFERENCE_SEARCH = exports.BCM_REFERENCE_DOWNLOAD = exports.BCM_PERMISSION_SETTING_UPDATE = exports.BCM_PERMISSION_SETTING_SEARCH = exports.BCM_NATURAL_DISASTER_SEARCH = exports.BCM_KUNREN_REPORT_TASK = exports.BCM_KUNREN_REPORT_SAVE = exports.BCM_KUNREN_REPORT_REGISTER = exports.BCM_KUNREN_REPORT_FILE_UPLOAD = exports.BCM_KUNREN_REPORT_FILE_DOWNLOAD = exports.BCM_KUNREN_REPORT_FILE_DELETE = exports.BCM_KUNREN_REPORT_DELETE = exports.BCM_KUNREN_REPORT = exports.BCM_KUNREN_MEDPLAN_REGISTER = exports.BCM_KUNREN_MEDPLAN = exports.BCM_KUNREN_GUIDANCE_SCENARIO = exports.BCM_KUNREN_GUIDANCE_SAVE = exports.BCM_KUNREN_GUIDANCE_REGISTER = exports.BCM_KUNREN_GUIDANCE_DELETE = exports.BCM_KUNREN_GUIDANCE = exports.BCM_KUNREN_DOCMNG_SEARCH_KUNREN = exports.BCM_KUNREN_DOCMNG_SEARCH = exports.BCM_KAISHA_SOSHIKI_SEARCH = exports.BCM_BCP_SEARCH = exports.BCM_ACTIVATION_REVIEW_SEARCH = exports.AUDIT_LOG = exports.AREA_UPDATE = exports.AREA_SITE_SELECT_SEARCH = exports.AREA_SELECT_SEARCH = exports.AREA_SEARCH = exports.AREA_REGISTER = exports.AREA_REFER = exports.AREA_ORDERING_SEARCH = exports.AREA_ORDERING_REGISTER = exports.AREA_ORDERING_REFER = exports.AREA_DELETE = exports.AREA_CHECK_LINK = void 0;
exports.RIGHTUSAGE_REGISTER = exports.PERSONAL_REGISTER = exports.PERSONAL_INFO_SEARCH = exports.PANDE_USERLIST_SEARCH = exports.PANDE_TOTALIZE = exports.PANDE_SEARCH_SHODOKU = exports.PANDE_SEARCH_REPORTINFO = exports.PANDE_SEARCH_REPORT = exports.PANDE_SEARCH_PROGRESS = exports.PANDE_REPORT_UPDATE = exports.PANDE_REPORT_REGISTER = exports.PANDE_REPORT_GET = exports.PANDE_REPORT_FOLLOWUP_SEARCH = exports.PANDE_REPORT_ENTRIES_GET = exports.PANDE_REPORT_DELETE = exports.PANDE_REGIST_INFO_UPDATE = exports.PANDE_REGIST_INFO_SEARCH = exports.PANDE_REGIST = exports.PANDE_PREVIOUS = exports.PANDE_MANUAL_DOWNLOAD = exports.PANDE_MAIL_TEMPlATE_LIST = exports.PANDE_MAIL_TEMPlATE_DATA = exports.PANDE_MAIL_TEMPLATE_UPD_RESULT = exports.PANDE_MAIL_TEMPLATE_UPD = exports.PANDE_HISTORY = exports.PANDE_FILE_UPLOAD = exports.PANDE_FILE_DOWNLOAD = exports.PANDE_FILE_DELETE = exports.PANDE_DOMAINS_GET = exports.PANDE_DETAIL = exports.PANDE_BROADCAST_SAVE_REGISTER = exports.PANDE_BROADCAST_SAVE_GET = exports.PANDE_BROADCAST_SAVE_DELETE = exports.PANDE_BROADCAST_QUOTE = exports.PANDE_AUTHORIZE_UPDATE = exports.PANDE_AUTHORIZE_SEARCH = exports.PANDE_AUTHORIZE_GET = exports.PANDE_AUTHORIZE_CLEAR = exports.NOTICE_UPDATE = exports.NOTICE_REGIST = exports.NOTICE_REFER = exports.NOTICE_QUOTE = exports.NOTICE_LATEST = exports.NOTICE_HISTORY = exports.MANUAL_DOWNLOAD = exports.LOGININFO = exports.LOCATION_SEARCH = exports.LINKAGE_SITE_UPDATE = exports.LINKAGE_SITE_SEARCH = exports.KANSA_TGT_UPDATE = exports.KANSA_TGT_REGISTER_DISP = exports.KANSA_TGT_REGISTER = exports.KANSA_TGT_JIGYO_BASIC = exports.KANSA_TARGET_LIST_SEARCH = exports.KANSA_TARGET_LIST_REGISTER = exports.KANSA_TARGET_LIST_DELETE = exports.KANSA_RESULT_UPDATE_SEARCH = exports.KANSA_RESULT_UPDATE = exports.KANSA_RESULT_SHITEKI_REGISTER_DISP = exports.KANSA_RESULT_SHITEKI_REGISTER = exports.KANSA_RESULT_SHITEKI_DISP = exports.KANSA_RESULT_SEIJUKUDO_CHECK = exports.KANSA_RESULT_SEIJUKUDO = exports.KANSA_RESULT_SEARCH = exports.KANSA_RESULT_REGISTER_TEMPSAVE = exports.KANSA_RESULT_REGISTER = exports.KANSA_RESULT_OLD_SHITEKI = exports.KANSA_RESULT_OLD_SEARCH = exports.KANSA_RESULT_KAKUNINJIKO_OLD = exports.KANSA_RESULT_KAKUNINJIKO = exports.KANSA_REPORT_SEARCH = exports.KANSA_REPORT_RP_REGISTER = exports.KANSA_REPORT_RP_REFER = exports.KANSA_REPORT_EV_REGISTER = exports.KANSA_REPORT_EV_REFER = exports.KANSA_REPORT_DETAIL = exports.KANSA_PROGRESS_SEARCH = exports.KANSA_NEND_SEARCH = exports.KANSA_AVAILABILITY = exports.KANSA_ANSWER_TRAIL_UPDATE = exports.KANSA_ANSWER_TRAIL_SEARCH = exports.KANSA_ANSWER_TRAIL_REGIST = exports.KANSA_ANSWER_TRAIL_FILE_DOWNLOAD = exports.KANSA_ANSWER_TRAIL_FILE_DELETE = exports.KANSA_ANSWER_SEARCH = exports.KANSA_ANSWER_REGIST_TEMPSAVE = exports.KANSA_ANSWER_REGIST_HIKANSA = exports.KANSA_ANSWER_REGIST = exports.KANSA_ANSWER_INIT_SEARCH = exports.KANSA_ANSWER_BCP_TRAIL_SEARCH = exports.KANSA_ANSWER_BCP_TRAIL_REGIST = exports.KAISHA_SOSHIKI_SEARCH = exports.KAISHA_SEARCH = exports.HOME_USER_INFO = exports.HOME_DISPLAY_SETTING_SET_GROUPHISAI = exports.HOME_DISPLAY_SETTING_INIT_GROUPHISAI = exports.HIKANSABUMON_CHIEF_HYOKA_REGISTER_TEMPSAVE = exports.HIKANSABUMON_CHIEF_HYOKA_REGISTER_DISP = exports.HIKANSABUMON_CHIEF_HYOKA_REGISTER = exports.HIKANSABUMON_CHIEF_HYOKA_DETAIL = void 0;
exports.USERLIST_SEARCH_ADMINSTRATOR = exports.USERLIST_SEARCH = exports.UPDATE_LOCALE = exports.UPDATE_FONTSIZE = exports.SYSLOGIN_REVOKE = exports.SYSLOGIN_LOGIN = exports.SYSLOGIN_APPROVE = exports.STATUS = exports.SITE_UPDATE = exports.SITE_SELECT_SEARCH = exports.SITE_SEARCH = exports.SITE_REGISTER = exports.SITE_REFER = exports.SITE_ORDERING_SEARCH = exports.SITE_ORDERING_REGISTER = exports.SITE_ORDERING_REFER = exports.SITE_LIST_SEARCH = exports.SITE_DELETE = exports.SITE_CHECK_LINK = exports.SITEMAP = exports.RIGHTUSAGE_SEARCH = void 0;
var _envUtil = _interopRequireWildcard(require("../logics/envUtil"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * APIのエンドポイントを定義する
 */

// サーバー識別子
const API = _envUtil.default.getEnv(_envUtil.ENV_KEY.CONTEXT_API_ROOT);

//正常
const SUCCESS = 'OK';
//異常
const ERROR = 'NG';
//タイムアウト
const TIMEOUT = 'TIMEOUT';

// レスポンスステータス
const STATUS = exports.STATUS = Object.freeze({
  SUCCESS,
  ERROR,
  TIMEOUT
});
// -----------------------------------------------
// 共通API
// -----------------------------------------------
// 業務識別子
const COMMON = API + '/common';

// ログイン
const SYSLOGIN_LOGIN = exports.SYSLOGIN_LOGIN = COMMON + '/login';

// ログアウト
const SYSLOGIN_REVOKE = exports.SYSLOGIN_REVOKE = COMMON + '/revoke';

// 個人情報保護同意
const SYSLOGIN_APPROVE = exports.SYSLOGIN_APPROVE = COMMON + '/approve';

// ログイン情報取得
const LOGININFO = exports.LOGININFO = COMMON + '/getlogininfo';

// メールアドレスチェック
const CHECK_MAIL_ADDRESS = exports.CHECK_MAIL_ADDRESS = COMMON + '/checkmailaddress';

// エラーログ収集
const FRONT_LOG = exports.FRONT_LOG = COMMON + '/frontlog';

// 監査ログ収集
const AUDIT_LOG = exports.AUDIT_LOG = COMMON + '/auditlog';

// ホーム用利用者情報
const HOME_USER_INFO = exports.HOME_USER_INFO = COMMON + '/home/userinfo';

// FAQ検索
const FAQ_SEARCH = exports.FAQ_SEARCH = COMMON + '/faq/search';

// FAQ分類検索
const FAQ_CATEGORY = exports.FAQ_CATEGORY = COMMON + '/faq/category/search';

// FAQ期間検索
const FAQ_PERIOD = exports.FAQ_PERIOD = COMMON + '/faq/period/search';

// FAQ画像取得
const FAQ_IMAGE = exports.FAQ_IMAGE = COMMON + '/faq/image';

// FAQ閲覧数更新
const FAQ_UPDATE = exports.FAQ_UPDATE = COMMON + '/faq/update';

// サイトマップ
const SITEMAP = exports.SITEMAP = COMMON + '/sitemap';

// ドキュメント取得
const DOCUMENTMNG_SEARCH = exports.DOCUMENTMNG_SEARCH = COMMON + '/documentmng/search';

// ドキュメントアップロード
const DOCUMENTMNG_UPLOAD = exports.DOCUMENTMNG_UPLOAD = COMMON + '/documentmng/upload';

// ドキュメント削除
const DOCUMENTMNG_DELETE = exports.DOCUMENTMNG_DELETE = COMMON + '/documentmng/delete';

// ドキュメントダウンロード
const DOCUMENTMNG_DOWNLOAD = exports.DOCUMENTMNG_DOWNLOAD = COMMON + '/documentmng/download';

// マニュアルダウンロード
const MANUAL_DOWNLOAD = exports.MANUAL_DOWNLOAD = COMMON + '/manual/download';

// -----------------------------------------------
// マスタデータ管理API
// -----------------------------------------------
// 業務識別子
const MASTERDATA = API + '/masterdata';

// disaster
// 災害情報登録
const DISASTER_REGIST = exports.DISASTER_REGIST = MASTERDATA + '/disaster/register';
// 災害情報検索
const DISASTER_SEARCH = exports.DISASTER_SEARCH = MASTERDATA + '/disaster/search';
// 災害情報詳細
const DISASTER_REFER = exports.DISASTER_REFER = MASTERDATA + '/disaster/refer';
// 災害情報更新
const DISASTER_UPDATE = exports.DISASTER_UPDATE = MASTERDATA + '/disaster/update';
// 災害情報削除
const DISASTER_DELETE = exports.DISASTER_DELETE = MASTERDATA + '/disaster/delete';
// 災害選択取得
const DISASTER_SELECT_SEARCH = exports.DISASTER_SELECT_SEARCH = MASTERDATA + '/disaster/select/search';

// group
// ユーザグループ検索
const GROUP_SEARCH = exports.GROUP_SEARCH = MASTERDATA + '/group/search';
// ユーザグループ登録
const GROUP_REGISTER = exports.GROUP_REGISTER = MASTERDATA + '/group/register';
// ユーザグループCSV登録
const GROUP_REGISTER_CSV = exports.GROUP_REGISTER_CSV = MASTERDATA + '/group/register/csv';
// ユーザグループ更新
const GROUP_UPDATE = exports.GROUP_UPDATE = MASTERDATA + '/group/update';
// ユーザグループ削除
const GROUP_DELETE = exports.GROUP_DELETE = MASTERDATA + '/group/delete';
// グループ選択一覧検索
const GROUP_LIST_SEARCH = exports.GROUP_LIST_SEARCH = MASTERDATA + '/group/list/search';
// グループ選択一覧検索（グループ検索用）
const GROUP_DETAILS_SEARCH = exports.GROUP_DETAILS_SEARCH = MASTERDATA + '/group/details/search';
// グループダウンロード
const GROUP_DOWNLOAD = exports.GROUP_DOWNLOAD = MASTERDATA + '/group/download';

// master&kaishaSoshiki&user
// 会社組織選択取得
const KAISHA_SOSHIKI_SEARCH = exports.KAISHA_SOSHIKI_SEARCH = MASTERDATA + '/kaishasoshiki/search';
// ユーザ選択一覧検索
const USERLIST_SEARCH = exports.USERLIST_SEARCH = MASTERDATA + '/userlist/search';
// ユーザ選択一覧検索
const USERLIST_SEARCH_ADMINSTRATOR = exports.USERLIST_SEARCH_ADMINSTRATOR = MASTERDATA + '/userlist/search/administrator';

// siteBuilding
// 建物選択取得
const BUILDING_SELECT_SEARCH = exports.BUILDING_SELECT_SEARCH = MASTERDATA + '/sitebuilding/select/buildingsearch';
// 地域選択取得
const AREA_SELECT_SEARCH = exports.AREA_SELECT_SEARCH = MASTERDATA + '/sitebuilding/select/areasearch';
// 拠点選択取得
const SITE_SELECT_SEARCH = exports.SITE_SELECT_SEARCH = MASTERDATA + '/sitebuilding/select/sitesearch';
// 拠点選択取得（地域選択時）
const AREA_SITE_SELECT_SEARCH = exports.AREA_SITE_SELECT_SEARCH = MASTERDATA + '/sitebuilding/select/areasitesearch';
// 拠点選択一覧取得
const SITE_LIST_SEARCH = exports.SITE_LIST_SEARCH = MASTERDATA + '/sitebuilding/search/site';
// 建物選択一覧取得
const BUILDING_LIST_SEARCH = exports.BUILDING_LIST_SEARCH = MASTERDATA + '/sitebuilding/search/building';

// rightusage
// 利用者権限検索
const RIGHTUSAGE_SEARCH = exports.RIGHTUSAGE_SEARCH = MASTERDATA + '/rightusage/search';
// 利用者権限設定
const RIGHTUSAGE_REGISTER = exports.RIGHTUSAGE_REGISTER = MASTERDATA + '/rightusage/register';

// bizexclusion
// 安否確認対象外設定検索
const BIZ_EXCLUSION_SEARCH = exports.BIZ_EXCLUSION_SEARCH = MASTERDATA + '/bizexclusion/search';
// 安否確認対象外設定
const BIZ_EXCLUSION_REGISTER = exports.BIZ_EXCLUSION_REGISTER = MASTERDATA + '/bizexclusion/register';
// 安否確認対象外設定確認
const BIZ_EXCLUSION_EXISTS = exports.BIZ_EXCLUSION_EXISTS = MASTERDATA + '/bizexclusion/exists';

// bcptgtjigyo
// BCP対象事業一覧取得
const BCPTGTJIGYO_SEARCH = exports.BCPTGTJIGYO_SEARCH = MASTERDATA + '/bcptgtjigyo/search';

// building
// 建物情報登録
const BUILDING_REGISTER = exports.BUILDING_REGISTER = MASTERDATA + '/building/register';
// 建物情報検索
const BUILDING_SEARCH = exports.BUILDING_SEARCH = MASTERDATA + '/building/search';
// 建物情報参照
const BUILDING_REFER = exports.BUILDING_REFER = MASTERDATA + '/building/refer';
// 建物情報更新
const BUILDING_UPDATE = exports.BUILDING_UPDATE = MASTERDATA + '/building/update';
// 建物情報削除
const BUILDING_DELETE = exports.BUILDING_DELETE = MASTERDATA + '/building/delete';

// site
// 拠点情報登録
const SITE_REGISTER = exports.SITE_REGISTER = MASTERDATA + '/site/register';
// 拠点情報検索
const SITE_SEARCH = exports.SITE_SEARCH = MASTERDATA + '/site/search';
// 拠点情報参照
const SITE_REFER = exports.SITE_REFER = MASTERDATA + '/site/refer';
// 拠点情報更新
const SITE_UPDATE = exports.SITE_UPDATE = MASTERDATA + '/site/update';
// 拠点情報削除
const SITE_DELETE = exports.SITE_DELETE = MASTERDATA + '/site/delete';
// 拠点情報に紐づいているデータチェック
const SITE_CHECK_LINK = exports.SITE_CHECK_LINK = MASTERDATA + '/site/check';
// 所在地検索
const LOCATION_SEARCH = exports.LOCATION_SEARCH = MASTERDATA + '/site/location/search';
// 拠点表示順設定検索
const SITE_ORDERING_SEARCH = exports.SITE_ORDERING_SEARCH = MASTERDATA + '/site/ordering/search';
// 拠点表示順設定登録
const SITE_ORDERING_REGISTER = exports.SITE_ORDERING_REGISTER = MASTERDATA + '/site/ordering/register';
// 拠点表示順設定詳細
const SITE_ORDERING_REFER = exports.SITE_ORDERING_REFER = MASTERDATA + '/site/ordering/refer';

// kaisha
// 会社情報取得
const KAISHA_SEARCH = exports.KAISHA_SEARCH = MASTERDATA + '/kaisha/search';

// area
// 地域情報登録
const AREA_REGISTER = exports.AREA_REGISTER = MASTERDATA + '/area/register';
// 地域情報検索
const AREA_SEARCH = exports.AREA_SEARCH = MASTERDATA + '/area/search';
// 地域情報参照
const AREA_REFER = exports.AREA_REFER = MASTERDATA + '/area/refer';
// 地域情報更新
const AREA_UPDATE = exports.AREA_UPDATE = MASTERDATA + '/area/update';
// 地域情報削除
const AREA_DELETE = exports.AREA_DELETE = MASTERDATA + '/area/delete';
// 地域情報チェック
const AREA_CHECK_LINK = exports.AREA_CHECK_LINK = MASTERDATA + '/area/check';
// 地域表示順設定検索
const AREA_ORDERING_SEARCH = exports.AREA_ORDERING_SEARCH = MASTERDATA + '/area/ordering/search';
// 地域表示順設定登録
const AREA_ORDERING_REGISTER = exports.AREA_ORDERING_REGISTER = MASTERDATA + '/area/ordering/register';
// 地域表示順設定詳細
const AREA_ORDERING_REFER = exports.AREA_ORDERING_REFER = MASTERDATA + '/area/ordering/refer';

// linkagesite
// 連携用拠点検索
const LINKAGE_SITE_SEARCH = exports.LINKAGE_SITE_SEARCH = MASTERDATA + '/linkagesite/search';
// 連携用拠点更新
const LINKAGE_SITE_UPDATE = exports.LINKAGE_SITE_UPDATE = MASTERDATA + '/linkagesite/update';

//bizuserregister
// 利用者登録
const BIZ_USER_REGISTER = exports.BIZ_USER_REGISTER = MASTERDATA + '/bizuser/register';

// 利用者更新
const BIZ_USER_UPDATE = exports.BIZ_USER_UPDATE = MASTERDATA + '/bizuser/update';

// ドメイン取得
const BIZ_USER_DOMAINS_GET = exports.BIZ_USER_DOMAINS_GET = MASTERDATA + '/bizuser/domains/get';

//bizusersearch
//利用者検索
const BIZ_USER_SEARCH = exports.BIZ_USER_SEARCH = MASTERDATA + '/bizuser/search';

//利用者情報参照
const BIZ_USER_REFER = exports.BIZ_USER_REFER = MASTERDATA + '/bizuser/refer';

//利用者情報削除
const BIZ_USER_DELETE = exports.BIZ_USER_DELETE = MASTERDATA + '/bizuser/delete';

//10階層会社組織選択
const BIZ_USER_KAISHA_SOSHIKI_SEARCH = exports.BIZ_USER_KAISHA_SOSHIKI_SEARCH = MASTERDATA + '/bizuser/kaishasoshiki';

// bizusercsvupload
// 利用者アップロード（CSV）登録・更新
const BIZ_USER_CSV_UPLOAD_REGISTERUPDATE = exports.BIZ_USER_CSV_UPLOAD_REGISTERUPDATE = MASTERDATA + '/bizusercsvupload/registerupdate';
// 利用者アップロード（CSV）削除
const BIZ_USER_CSV_UPLOAD_DELETE = exports.BIZ_USER_CSV_UPLOAD_DELETE = MASTERDATA + '/bizusercsvupload/delete';

// bizusercommon
// 利用者登録機能共通ファイルダウンロード
const BIZ_USER_COMMON_DOWNLOAD = exports.BIZ_USER_COMMON_DOWNLOAD = MASTERDATA + '/bizusercommon/download';
// 利用者登録機能共通利用者情報補足取得
const BIZ_USER_COMMON_BIZ_USER_INFO = exports.BIZ_USER_COMMON_BIZ_USER_INFO = MASTERDATA + '/bizusercommon/bizuserinfo';

// -----------------------------------------------
//  利用者カスタマイズAPI
// -----------------------------------------------
// 業務識別子
const USERCUSTOM = API + '/usercustom';

// 言語設定更新
const UPDATE_LOCALE = exports.UPDATE_LOCALE = USERCUSTOM + '/updateLocale';

// 文字サイズ変更
const UPDATE_FONTSIZE = exports.UPDATE_FONTSIZE = USERCUSTOM + '/updateFontsize';

// 個人情報取得
const PERSONAL_INFO_SEARCH = exports.PERSONAL_INFO_SEARCH = USERCUSTOM + '/personalinfo/search';

// 個人情報登録
const PERSONAL_REGISTER = exports.PERSONAL_REGISTER = USERCUSTOM + '/personalinfo/register';

// -----------------------------------------------
// メンテナンス情報管理API
// -----------------------------------------------
// 業務識別子
const NOTICE = API + '/notice';

// メンテナンス情報登録
const NOTICE_REGIST = exports.NOTICE_REGIST = NOTICE + '/register';

// メンテナンス情報参照
const NOTICE_REFER = exports.NOTICE_REFER = NOTICE + '/refer';

// メンテナンス情報履歴取得
const NOTICE_HISTORY = exports.NOTICE_HISTORY = NOTICE + '/history';

// 前回のメンテナンス情報取得
const NOTICE_QUOTE = exports.NOTICE_QUOTE = NOTICE + '/quote';

// メンテナンス情報更新
const NOTICE_UPDATE = exports.NOTICE_UPDATE = NOTICE + '/update';

// メンテナンス情報最新取得
const NOTICE_LATEST = exports.NOTICE_LATEST = NOTICE + '/latest';

// -----------------------------------------------
// グループ被災情報API
// -----------------------------------------------
// 業務識別子
const GROUPHISAI = API + '/grouphisai';

// グループ被災情報区分
const GROUPHISAI_KBN = exports.GROUPHISAI_KBN = GROUPHISAI + '/grouphisaikbn';

// グループ被災情報検索
const GROUPHISAI_SEARCH = exports.GROUPHISAI_SEARCH = GROUPHISAI + '/search';

// グループ被災情報詳細
const GROUPHISAI_DETAIL = exports.GROUPHISAI_DETAIL = GROUPHISAI + '/detail';

// グループ被災情報更新
const GROUPHISAI_UPDATE_INFO = exports.GROUPHISAI_UPDATE_INFO = GROUPHISAI + '/update_info';

// グループ被災情報履歴
const GROUPHISAI_HISTORY = exports.GROUPHISAI_HISTORY = GROUPHISAI + '/history';

// グループ被災情報削除
const GROUPHISAI_DELETE = exports.GROUPHISAI_DELETE = GROUPHISAI + '/delete';

// グループ被災情報詳細 ファイルダウンロード
const GROUPHISAI_DOWNLOAD = exports.GROUPHISAI_DOWNLOAD = GROUPHISAI + '/download';

// ホーム用グループ被災情報検索
const GROUPHISAI_HOMELIST = exports.GROUPHISAI_HOMELIST = GROUPHISAI + '/homelist';

// グループ被災情報振り分け
const GROUPHISAI_SORT = exports.GROUPHISAI_SORT = GROUPHISAI + '/sort';

// ホーム表示設定－NECグループ被災情報の表示設定(登録／削除)
const HOME_DISPLAY_SETTING_SET_GROUPHISAI = exports.HOME_DISPLAY_SETTING_SET_GROUPHISAI = GROUPHISAI + '/homedisplaysetting/grouphisai/set';

// ホーム表示設定－NECグループ被災情報の表示設定初回登録
const HOME_DISPLAY_SETTING_INIT_GROUPHISAI = exports.HOME_DISPLAY_SETTING_INIT_GROUPHISAI = GROUPHISAI + '/homedisplaysetting/grouphisai/init';

// グループ被災情報更新（掲載先設定）
const GROUPHISAI_UPDATE = exports.GROUPHISAI_UPDATE = GROUPHISAI + '/update';

// -----------------------------------------------
// 感染症情報API
// -----------------------------------------------
// 業務識別子
const PANDE = API + '/pande';

// 感染症検索（管理表）
const PANDE_SEARCH_REPORT = exports.PANDE_SEARCH_REPORT = PANDE + '/search/report';

// 感染症検索（報告遅延アラート）
const PANDE_SEARCH_PROGRESS = exports.PANDE_SEARCH_PROGRESS = PANDE + '/search/progress';

// 感染症検索（消毒）
const PANDE_SEARCH_SHODOKU = exports.PANDE_SEARCH_SHODOKU = PANDE + '/search/shodoku';

// 感染症検索報告詳細情報
const PANDE_SEARCH_REPORTINFO = exports.PANDE_SEARCH_REPORTINFO = PANDE + '/search/reportinfo';

// 感染症情報登録
const PANDE_REGIST = exports.PANDE_REGIST = PANDE + '/register';

// 感染症補足説明検索
const PANDE_REGIST_INFO_SEARCH = exports.PANDE_REGIST_INFO_SEARCH = PANDE + '/register/info/search';

// 感染症補足説明更新
const PANDE_REGIST_INFO_UPDATE = exports.PANDE_REGIST_INFO_UPDATE = PANDE + '/register/info/update';

// 感染症補足説明更新
const PANDE_PREVIOUS = exports.PANDE_PREVIOUS = PANDE + '/previous';

// 感染症詳細情報
const PANDE_DETAIL = exports.PANDE_DETAIL = PANDE + '/detail';

// 感染症履歴
const PANDE_HISTORY = exports.PANDE_HISTORY = PANDE + '/history';

// 感染症集計
const PANDE_TOTALIZE = exports.PANDE_TOTALIZE = PANDE + '/totalize';

// 感染症報告項目、補足情報取得
const PANDE_REPORT_ENTRIES_GET = exports.PANDE_REPORT_ENTRIES_GET = PANDE + '/report/entries/get';

// 感染症報告情報取得
const PANDE_REPORT_GET = exports.PANDE_REPORT_GET = PANDE + '/report/get';

// 感染症報告情報登録
const PANDE_REPORT_REGISTER = exports.PANDE_REPORT_REGISTER = PANDE + '/report/register';

// 感染症報告情報更新
const PANDE_REPORT_UPDATE = exports.PANDE_REPORT_UPDATE = PANDE + '/report/update';

// 感染症報告情報削除
const PANDE_REPORT_DELETE = exports.PANDE_REPORT_DELETE = PANDE + '/report/delete';

// 感染症報告でログインユーザが選択できる報告検索
const PANDE_REPORT_FOLLOWUP_SEARCH = exports.PANDE_REPORT_FOLLOWUP_SEARCH = PANDE + '/report/followup/search';

// 感染症報告ドキュメントダウンロード
const PANDE_MANUAL_DOWNLOAD = exports.PANDE_MANUAL_DOWNLOAD = PANDE + '/doc/download';

// ユーザ選択一覧検索（感染症報告用）
const PANDE_USERLIST_SEARCH = exports.PANDE_USERLIST_SEARCH = PANDE + '/userlist/search';

// ファイルアップロード
const PANDE_FILE_UPLOAD = exports.PANDE_FILE_UPLOAD = PANDE + '/file/upload';

// アップロードファイル削除
const PANDE_FILE_DELETE = exports.PANDE_FILE_DELETE = PANDE + '/file/delete';

// ファイルダウンロード
const PANDE_FILE_DOWNLOAD = exports.PANDE_FILE_DOWNLOAD = PANDE + '/file/download';

// メールアドレスドメイン情報取得
const PANDE_DOMAINS_GET = exports.PANDE_DOMAINS_GET = PANDE + '/domains/get';

// メールテンプレート一覧情報取得
const PANDE_MAIL_TEMPlATE_LIST = exports.PANDE_MAIL_TEMPlATE_LIST = PANDE + '/mailtemplate/list';

// メールテンプレート情報取得
const PANDE_MAIL_TEMPlATE_DATA = exports.PANDE_MAIL_TEMPlATE_DATA = PANDE + '/mailtemplate/data';

// メールテンプレート本文更新
const PANDE_MAIL_TEMPLATE_UPD = exports.PANDE_MAIL_TEMPLATE_UPD = PANDE + '/mailtemplate/upd';

// メールテンプレート本文更新結果取得
const PANDE_MAIL_TEMPLATE_UPD_RESULT = exports.PANDE_MAIL_TEMPLATE_UPD_RESULT = PANDE + '/mailtemplate/upd/result';

// 報告者・引用
const PANDE_BROADCAST_QUOTE = exports.PANDE_BROADCAST_QUOTE = PANDE + '/report/quote';

// 同報先情報保存登録
const PANDE_BROADCAST_SAVE_REGISTER = exports.PANDE_BROADCAST_SAVE_REGISTER = PANDE + '/report/save/register';

// 同報先情報保存取得
const PANDE_BROADCAST_SAVE_GET = exports.PANDE_BROADCAST_SAVE_GET = PANDE + '/report/save/get';

// 同報先情報保存削除
const PANDE_BROADCAST_SAVE_DELETE = exports.PANDE_BROADCAST_SAVE_DELETE = PANDE + '/report/save/delete';

// 感染症利用権限検索
const PANDE_AUTHORIZE_SEARCH = exports.PANDE_AUTHORIZE_SEARCH = PANDE + '/authorize/search';

// 感染症利用権限取得
const PANDE_AUTHORIZE_GET = exports.PANDE_AUTHORIZE_GET = PANDE + '/authorize/get';

// 感染症利用権限クリア
const PANDE_AUTHORIZE_CLEAR = exports.PANDE_AUTHORIZE_CLEAR = PANDE + '/authorize/clear';

// 感染症利用権限更新
const PANDE_AUTHORIZE_UPDATE = exports.PANDE_AUTHORIZE_UPDATE = PANDE + '/authorize/update';

// -----------------------------------------------
// 内部監査情報API
// -----------------------------------------------
// 業務識別子
const KANSA = API + '/kansa';

// 機能利用可否判定
const KANSA_AVAILABILITY = exports.KANSA_AVAILABILITY = KANSA + '/availability';

// 監査回答情報検索
const KANSA_ANSWER_SEARCH = exports.KANSA_ANSWER_SEARCH = KANSA + '/answer/search';

// 監査回答登録（回答登録）
const KANSA_ANSWER_REGIST = exports.KANSA_ANSWER_REGIST = KANSA + '/answer/register';

// 監査回答登録（被監査部門回答登録）
const KANSA_ANSWER_REGIST_HIKANSA = exports.KANSA_ANSWER_REGIST_HIKANSA = KANSA + '/answer/register/hikansa';

// 監査回答登録（一時保存）
const KANSA_ANSWER_REGIST_TEMPSAVE = exports.KANSA_ANSWER_REGIST_TEMPSAVE = KANSA + '/answer/register/tempsave';

// 監査回答情報初期情報検索
const KANSA_ANSWER_INIT_SEARCH = exports.KANSA_ANSWER_INIT_SEARCH = KANSA + '/answer/init/search';

// 監査証跡情報検索
const KANSA_ANSWER_TRAIL_SEARCH = exports.KANSA_ANSWER_TRAIL_SEARCH = KANSA + '/answer/trail/search';

// 監査BCP証跡情報検索
const KANSA_ANSWER_BCP_TRAIL_SEARCH = exports.KANSA_ANSWER_BCP_TRAIL_SEARCH = KANSA + '/answer/bcptrail/search';

// 監査証跡ファイルダウンロード
const KANSA_ANSWER_TRAIL_FILE_DOWNLOAD = exports.KANSA_ANSWER_TRAIL_FILE_DOWNLOAD = KANSA + '/answer/trail/download';

// 監査証跡ファイル削除
const KANSA_ANSWER_TRAIL_FILE_DELETE = exports.KANSA_ANSWER_TRAIL_FILE_DELETE = KANSA + '/answer/trail/delete';

// 監査証跡登録
const KANSA_ANSWER_TRAIL_REGIST = exports.KANSA_ANSWER_TRAIL_REGIST = KANSA + '/answer/trail/register';

// 監査証跡更新
const KANSA_ANSWER_TRAIL_UPDATE = exports.KANSA_ANSWER_TRAIL_UPDATE = KANSA + '/answer/trail/update';

// 監査BCP証跡登録
const KANSA_ANSWER_BCP_TRAIL_REGIST = exports.KANSA_ANSWER_BCP_TRAIL_REGIST = KANSA + '/answer/bcptrail/register';

// 監査進捗状況検索
const KANSA_PROGRESS_SEARCH = exports.KANSA_PROGRESS_SEARCH = KANSA + '/progress/search';

// 監査対象事業基本情報取得
const KANSA_TGT_JIGYO_BASIC = exports.KANSA_TGT_JIGYO_BASIC = KANSA + '/target/jigyo/basic';

// 監査対象年度取得
const KANSA_NEND_SEARCH = exports.KANSA_NEND_SEARCH = KANSA + '/nendo/search';

// 指摘事項改善計画・実績表示一覧検索
const KANSA_RESULT_SHITEKI_DISP = exports.KANSA_RESULT_SHITEKI_DISP = KANSA + '/result/shiteki/display';

// 指摘事項改善計画・実績登録一覧検索
const KANSA_RESULT_SHITEKI_REGISTER_DISP = exports.KANSA_RESULT_SHITEKI_REGISTER_DISP = KANSA + '/result/shiteki/register/display';

// 指摘事項改善計画・実績表示（詳細版）検索
const KANSA_RESULT_OLD_SHITEKI = exports.KANSA_RESULT_OLD_SHITEKI = KANSA + '/result/shiteki/old';

// 指摘事項改善計画・実績登録
const KANSA_RESULT_SHITEKI_REGISTER = exports.KANSA_RESULT_SHITEKI_REGISTER = KANSA + '/result/shiteki/register';

// 成熟度チェック
const KANSA_RESULT_SEIJUKUDO_CHECK = exports.KANSA_RESULT_SEIJUKUDO_CHECK = KANSA + '/result/seijukudo/check';

// 被監査部門責任者評価登録
const HIKANSABUMON_CHIEF_HYOKA_REGISTER = exports.HIKANSABUMON_CHIEF_HYOKA_REGISTER = KANSA + '/result/hikansa/register';

// 被監査部門責任者評価登録（一時保存）
const HIKANSABUMON_CHIEF_HYOKA_REGISTER_TEMPSAVE = exports.HIKANSABUMON_CHIEF_HYOKA_REGISTER_TEMPSAVE = KANSA + '/result/hikansa/tempsave';

// 被監査部門責任者評価登録情報取得
const HIKANSABUMON_CHIEF_HYOKA_REGISTER_DISP = exports.HIKANSABUMON_CHIEF_HYOKA_REGISTER_DISP = KANSA + '/result/hikansa/register/display';

// 被監査部門責任者評価表示
const HIKANSABUMON_CHIEF_HYOKA_DETAIL = exports.HIKANSABUMON_CHIEF_HYOKA_DETAIL = KANSA + '/result/hikansa/detail';

// 監査対象事業登録情報取得
const KANSA_TGT_REGISTER_DISP = exports.KANSA_TGT_REGISTER_DISP = KANSA + '/target/register/display';

// 監査対象事業登録
const KANSA_TGT_REGISTER = exports.KANSA_TGT_REGISTER = KANSA + '/target/register';

// 監査対象事業更新
const KANSA_TGT_UPDATE = exports.KANSA_TGT_UPDATE = KANSA + '/target/update';

// 監査結果一覧検索
const KANSA_RESULT_SEARCH = exports.KANSA_RESULT_SEARCH = KANSA + '/result/search';

// 監査結果検索（更新用）
const KANSA_RESULT_UPDATE_SEARCH = exports.KANSA_RESULT_UPDATE_SEARCH = KANSA + '/result/update/search';

// 監査結果（詳細）検索
const KANSA_RESULT_OLD_SEARCH = exports.KANSA_RESULT_OLD_SEARCH = KANSA + '/result/old/search';

// 監査結果登録・更新
const KANSA_RESULT_REGISTER = exports.KANSA_RESULT_REGISTER = KANSA + '/result/register';

// 監査結果登録・更新（一時保存）
const KANSA_RESULT_REGISTER_TEMPSAVE = exports.KANSA_RESULT_REGISTER_TEMPSAVE = KANSA + '/result/tempsave';

// 監査結果更新
const KANSA_RESULT_UPDATE = exports.KANSA_RESULT_UPDATE = KANSA + '/result/update';

// 確認事項一覧情報取得
const KANSA_RESULT_KAKUNINJIKO = exports.KANSA_RESULT_KAKUNINJIKO = KANSA + '/result/kakuninjiko';

// 監査回答成熟度情報取得
const KANSA_RESULT_SEIJUKUDO = exports.KANSA_RESULT_SEIJUKUDO = KANSA + '/result/seijukudo';

// 確認事項一覧情報取得（詳細画面）
const KANSA_RESULT_KAKUNINJIKO_OLD = exports.KANSA_RESULT_KAKUNINJIKO_OLD = KANSA + '/result/kakuninjiko/old';

// 監査対象事業一覧(検索)
const KANSA_TARGET_LIST_SEARCH = exports.KANSA_TARGET_LIST_SEARCH = KANSA + '/targetlist/search';

// 監査対象事業一覧(削除)
const KANSA_TARGET_LIST_DELETE = exports.KANSA_TARGET_LIST_DELETE = KANSA + '/targetlist/delete';

// 監査対象事業一覧(登録)
const KANSA_TARGET_LIST_REGISTER = exports.KANSA_TARGET_LIST_REGISTER = KANSA + '/targetlist/register';

// 監査報告書検索
const KANSA_REPORT_SEARCH = exports.KANSA_REPORT_SEARCH = KANSA + '/report/search';

// 監査報告書参照
const KANSA_REPORT_RP_REFER = exports.KANSA_REPORT_RP_REFER = KANSA + '/report/rp/refer';

// 監査報告書登録
const KANSA_REPORT_RP_REGISTER = exports.KANSA_REPORT_RP_REGISTER = KANSA + '/report/rp/register';

// 監査報告書評価参照
const KANSA_REPORT_EV_REFER = exports.KANSA_REPORT_EV_REFER = KANSA + '/report/ev/refer';

// 監査報告書評価登録
const KANSA_REPORT_EV_REGISTER = exports.KANSA_REPORT_EV_REGISTER = KANSA + '/report/ev/register';

// 監査報告詳細検索
const KANSA_REPORT_DETAIL = exports.KANSA_REPORT_DETAIL = KANSA + '/report/detail';

// -----------------------------------------------
// BCMAPI
// -----------------------------------------------
// 業務識別子
const BCM = API + '/bcm';

// BCM会社組織情報取得
const BCM_KAISHA_SOSHIKI_SEARCH = exports.BCM_KAISHA_SOSHIKI_SEARCH = BCM + '/bcmkaishasoshiki/search';

// 訓練中期計画登録情報取得
const BCM_KUNREN_MEDPLAN = exports.BCM_KUNREN_MEDPLAN = BCM + '/kunren/medplan';

// 訓練中期計画情報登録
const BCM_KUNREN_MEDPLAN_REGISTER = exports.BCM_KUNREN_MEDPLAN_REGISTER = BCM + '/kunren/medplan/register';

// 訓練実施報告登録情報取得
const BCM_KUNREN_REPORT = exports.BCM_KUNREN_REPORT = BCM + '/kunren/report';

// 訓練実施参加者名簿ファイルダウンロード
const BCM_KUNREN_REPORT_FILE_DOWNLOAD = exports.BCM_KUNREN_REPORT_FILE_DOWNLOAD = BCM + '/kunren/report/file/download';

// 訓練実施参加者名簿ファイルダウンロード
const BCM_KUNREN_REPORT_FILE_DELETE = exports.BCM_KUNREN_REPORT_FILE_DELETE = BCM + '/kunren/report/file/delete';

// 訓練実施参加者名簿ファイルダウンロード
const BCM_KUNREN_REPORT_FILE_UPLOAD = exports.BCM_KUNREN_REPORT_FILE_UPLOAD = BCM + '/kunren/report/file/upload';

// 訓練課題のセレクトボックスを取得
const BCM_KUNREN_REPORT_TASK = exports.BCM_KUNREN_REPORT_TASK = BCM + '/kunren/report/task';

// 訓練実施報告登録
const BCM_KUNREN_REPORT_REGISTER = exports.BCM_KUNREN_REPORT_REGISTER = BCM + '/kunren/report/register';

// 訓練実施報告登録
const BCM_KUNREN_REPORT_SAVE = exports.BCM_KUNREN_REPORT_SAVE = BCM + '/kunren/report/save';

// 訓練実施報告削除
const BCM_KUNREN_REPORT_DELETE = exports.BCM_KUNREN_REPORT_DELETE = BCM + '/kunren/report/delete';

// ドキュメント管理（訓練）訓練情報取得
const BCM_KUNREN_DOCMNG_SEARCH_KUNREN = exports.BCM_KUNREN_DOCMNG_SEARCH_KUNREN = BCM + '/kunren/docmng/search/kunren';

// ドキュメント管理（訓練）訓練一覧取得
const BCM_KUNREN_DOCMNG_SEARCH = exports.BCM_KUNREN_DOCMNG_SEARCH = BCM + '/kunren/docmng/search';

// BCM静的ページ_画面表示情報取得
const BCM_REFERENCE_SEARCH = exports.BCM_REFERENCE_SEARCH = BCM + '/bcmreference/search';

// BCM静的ページ_ファイルファイルダウンロード
const BCM_REFERENCE_DOWNLOAD = exports.BCM_REFERENCE_DOWNLOAD = BCM + '/bcmreference/download';

// 対象組織情報取得
const BCM_TARGET_REGISTER_KAISHA_SOSHIKI = exports.BCM_TARGET_REGISTER_KAISHA_SOSHIKI = BCM + '/targetregister/kaishasoshiki';

// BCP対象事業登録
const BCM_TARGET_REGISTER = exports.BCM_TARGET_REGISTER = BCM + '/targetregister/register';

// 対象事業利用ユーザ追加検索
const BCM_PERMISSION_SETTING_SEARCH = exports.BCM_PERMISSION_SETTING_SEARCH = BCM + '/bcmpermissionsetting/search';

// 対象事業利用ユーザ追加更新
const BCM_PERMISSION_SETTING_UPDATE = exports.BCM_PERMISSION_SETTING_UPDATE = BCM + '/bcmpermissionsetting/update';

// 訓練実施要領・訓練シナリオ登録情報取得
const BCM_KUNREN_GUIDANCE = exports.BCM_KUNREN_GUIDANCE = BCM + '/kunren/guidance';

// 訓練実施要領・訓練シナリオ登録情報取得
const BCM_KUNREN_GUIDANCE_SCENARIO = exports.BCM_KUNREN_GUIDANCE_SCENARIO = BCM + '/kunren/guidance/scenario';

// 訓練実施要領・訓練シナリオ情報登録
const BCM_KUNREN_GUIDANCE_REGISTER = exports.BCM_KUNREN_GUIDANCE_REGISTER = BCM + '/kunren/guidance/register';

// 訓練実施要領・訓練シナリオ情報登録
const BCM_KUNREN_GUIDANCE_SAVE = exports.BCM_KUNREN_GUIDANCE_SAVE = BCM + '/kunren/guidance/save';

// 訓練実施要領・訓練シナリオ登録情報削除
const BCM_KUNREN_GUIDANCE_DELETE = exports.BCM_KUNREN_GUIDANCE_DELETE = BCM + '/kunren/guidance/delete';

// ドキュメント管理（発動後レビュー）実施時期取得
const BCM_SITE_KIND_INFO = exports.BCM_SITE_KIND_INFO = BCM + '/document/activationreview/sitekindinfo';

// ドキュメント管理（発動後レビュー）検索
const BCM_ACTIVATION_REVIEW_SEARCH = exports.BCM_ACTIVATION_REVIEW_SEARCH = BCM + '/document/activationreview/search';

// ドキュメント管理（自然災害）検索
const BCM_NATURAL_DISASTER_SEARCH = exports.BCM_NATURAL_DISASTER_SEARCH = BCM + '/document/naturaldisaster/search';

// BCP対象事業一覧取得
const BCM_TARGET_SEARCH = exports.BCM_TARGET_SEARCH = BCM + '/targetsearch/search';

// BCP対象事業更新
const BCM_TARGET_SEARCH_UPDATE = exports.BCM_TARGET_SEARCH_UPDATE = BCM + '/targetsearch/update';

// BCP対象事業削除
const BCM_TARGET_SEARCH_DELETE = exports.BCM_TARGET_SEARCH_DELETE = BCM + '/targetsearch/delete';

// BCP検索結果一覧取得
const BCM_BCP_SEARCH = exports.BCM_BCP_SEARCH = BCM + '/bcmmap/search';